import { useEffect, useState } from 'react'
import { useAuthContext } from 'components/auth'
import { useIntercom } from 'react-use-intercom'
import { useIntercomJwt } from 'queries/user'

export const Intercom = () => {
  const { user } = useAuthContext()
  const { boot, update } = useIntercom()
  const [hasBooted, setHasBooted] = useState(false)
  const { data: intercomJwt } = useIntercomJwt(user?.uid)

  useEffect(() => {
    if (intercomJwt) {
      const intercomUser = {
        intercomUserJwt: intercomJwt,
        customAttributes: {
          status: 'client',
          type: 'client',
        },
        // The navbar's Support button opens the messenger instead
        hideDefaultLauncher: true,
      }

      if (hasBooted) {
        update(intercomUser)
      } else {
        boot(intercomUser)
        setHasBooted(true)
      }
    }
  }, [intercomJwt])

  return null
}
